// new CustomEvent('price:change', { detail: { id: PRODUCT ID, price: FORMATTED PRICE }})

if (!customElements.get('product-button-price')) {
  class ProductButtonPrice extends HTMLElement {
    constructor() {
      super();
      this.handlePriceChangeRef = this.handlePriceChange.bind(this);
    }

    handlePriceChange(event) {
      if (event.detail.id != this.getAttribute('js-id')) return;
      if (!event.detail.price) return;

      // Préserver le prix barré (del) s'il existe
      const existingDel = this.querySelector('del');
      if (existingDel) {
        // Remplacer seulement le prix principal, garder le prix barré
        const insElement = this.querySelector('ins');
        if (insElement) {
          insElement.innerHTML = event.detail.price;
        } else {
          // Créer la structure avec ins et del
          this.innerHTML = `<ins>${event.detail.price}</ins>${existingDel.outerHTML}`;
        }
      } else {
        // Pas de prix barré, remplacer normalement
        this.innerHTML = event.detail.price;
      }
    }

    disconnectedCallback() {
      document.removeEventListener('price:change', this.handlePriceChangeRef);
    }

    connectedCallback() {
      document.addEventListener('price:change', this.handlePriceChangeRef);
    }
  }

  customElements.define('product-button-price', ProductButtonPrice);
}
